import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from '@mui/material'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { CustomDialogTitle } from './CustomerStyledComponents'
const ConfirmationModal = ({ open, onClose, onConfirm, title, message }) => {
  const { t } = useTranslation('confirmation_modal')
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <CustomDialogTitle>
        <div>
          <h5>{title}</h5>
        </div>
        <Button
          style={{
            color: 'inherit',
            fontSize: '1rem',
          }}
          onClick={onClose}
        >
          X
        </Button>
      </CustomDialogTitle>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="warning">
          {t('cancel')}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
}

export default ConfirmationModal
